// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mb-c";
export var backButton = "_mb-4";
export var backIcon = "_mb-5";
export var chevronShortcut = "_mb-6";
export var container = "_mb-1";
export var editor = "_mb-8";
export var editorWrapper = "_mb-7";
export var prefix = "_mb-2";
export var searchIcon = "_mb-3";
export var suffix = "_mb-9";
export var suffixContent = "_mb-a";
export var suffixText = "_mb-b";
export var wrapper = "_mb-0";